import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedButton from "./AnimatedButton";

const slides = [
  { url: process.env.PUBLIC_URL + "/images/slide.png", caption: "Premium Colors" },
  { url: process.env.PUBLIC_URL + "/images/slide2.png", caption: "Smooth Finish" },
  {url: process.env.PUBLIC_URL + "/images/slide3.png", caption: "Designed for Elegant Living"},
  {url: process.env.PUBLIC_URL + "/images/slide4.png", caption: "Luxury in Every Coat"},
];

export default function HeroSlider() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const startXRef = useRef(null);

  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => {
      setIndex(i => (i + 1) % slides.length);
    }, 3000);
    return () => clearInterval(id);
  }, [paused]);

  useEffect(() => {
    slides.forEach(slide => {
      const img = new Image();
      img.src = slide.url;
    });
  }, []);

  useEffect(() => {
    const onVis = () => {
      if (document.hidden) setPaused(true);
      else setPaused(false);
    };
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  const prev = () => setIndex(i => (i - 1 + slides.length) % slides.length);
  const next = () => setIndex(i => (i + 1) % slides.length);

  const onTouchStart = (e) => {
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    startXRef.current = x;
    setPaused(true);
  };
  const onTouchEnd = (e) => {
    const x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    if (startXRef.current == null) { setPaused(false); return; }
    const dx = x - startXRef.current;
    if (Math.abs(dx) > 40) { if (dx > 0) prev(); else next(); }
    startXRef.current = null;
    setPaused(false);
  };

  return (
    <section className="hero">
      <div
        className="hero-slider"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onPointerDown={onTouchStart}
        onPointerUp={onTouchEnd}
      >
        {slides.map((slide, i) => (
          <div key={i} className={`slide fade ${i === index ? "active" : ""}`} style={{ backgroundImage: `url(${slide.url})` }}>
            <div className="overlay">
              <h1 className="slide-title">{slide.caption}</h1>
              <div className="cta-buttons">
                {/* <AnimatedButton className="primary" onClick={() => navigate("/products")}>Explore Products</AnimatedButton> */}
                <AnimatedButton onClick={() => navigate("/about")}>About Us</AnimatedButton>
                <AnimatedButton onClick={() => navigate("/contact")}>Contact</AnimatedButton>
              </div>
            </div>
          </div>
        ))}
        <button className="nav-btn left" onClick={prev} aria-label="Previous">&#10094;</button>
        <button className="nav-btn right" onClick={next} aria-label="Next">&#10095;</button>
        <div className="dots">
          {slides.map((_, i) => (
            <span key={i} className={i === index ? "dot active" : "dot"} onClick={() => setIndex(i)} />
          ))}
        </div>
      </div>
    </section>
  );
}